// extracted by css-extract-rspack-plugin
export default {"alertNumber":"CustomAlerts__alertNumber--Bud0X","notParentheses":"CustomAlerts__notParentheses--NKPSo"};